import { requestNotificationPermission } from "../firebase";
import { createOrUpdateFCMDevice } from "../api";
import { v4 as uuidv4 } from "uuid";

// Obtener o generar un device_id
export const getDeviceId = () => {
  let deviceId = localStorage.getItem("device_id");
  if (!deviceId) {
    deviceId = uuidv4();
    localStorage.setItem("device_id", deviceId);
  }
  return deviceId;
};

// Sincronizar token FCM si hay un usuario logueado
export const syncFCMTokenIfLoggedIn = async (user) => {
  if (!user || !user.email) return;

  try {
    const token = await requestNotificationPermission();
    if (!token) {
      console.warn("Token FCM no obtenido o permiso denegado.");
      return;
    }

    // Sincronizar con el backend
    const data = {
      name: `Dispositivo de ${user.email}`,
      registration_id: token,
      type: "web",
      device_id: getDeviceId(),
      active: true,
    };
    await createOrUpdateFCMDevice(data);
    // console.info("✅ Token FCM sincronizado con el backend.");
  } catch (err) {
    console.error("❌ Error al sincronizar FCM token:", err);
  }
};
